import { useEffect, useState } from "react";

import clsx from "clsx";
import { useToasts } from "react-toast-notifications";
import { twMerge } from "tailwind-merge";

import { type AppcuesCallback } from "@/types/appcues";
import Spinner from "@shared/spinner";

interface Props {
  formId: string;
  className?: string;
}

export const FeedbackForm = ({ formId, className }: Props) => {
  const { addToast } = useToasts();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleFlowCompleted: AppcuesCallback = (event) => {
      if (event.flowId === formId) {
        setLoading(false);
        addToast("Thank you for your feedback", {
          appearance: "success",
        });
      }
    };

    const handleFlowSkipped: AppcuesCallback = (event) => {
      if (event.flowId === formId) {
        setLoading(false);
      }
    };

    if (window.Appcues) {
      window.Appcues.on("flow_completed", handleFlowCompleted);
      window.Appcues.on("flow_skipped", handleFlowSkipped);
    }

    return () => {
      if (window.Appcues) {
        window.Appcues.off("flow_completed", handleFlowCompleted);
        window.Appcues.off("flow_skipped", handleFlowSkipped);
      }
    };
  }, []);

  return (
    <div
      className={twMerge("fixed right-[30px] bottom-[30px] z-50", className)}
    >
      <button
        disabled={loading}
        className={clsx(
          "block bg-v2-highlight-information hover:bg-cosmic h-[40px] group",
          "flex items-center justify-center rounded-full shadow-sm",
          "text-sm text-v2-action gap-2 hover:text-white px-4",
        )}
        onClick={() => {
          if (window.Appcues) {
            setLoading(true);
            window.Appcues.show(formId);
          }
        }}
      >
        {loading && (
          <Spinner colorClassname="text-cosmic group-hover:text-white -ml-0.5" />
        )}
        {!loading && (
          <i
            className={clsx(
              "fa-regular fa-message text-v2-action group-hover:text-white text-sm mt-0.5",
            )}
          ></i>
        )}
        Help & Feedback
      </button>
    </div>
  );
};
